import {CALL_API} from 'redux-api-middleware';
import {
  API_ORG_PROGRAM_GET_REQUEST,
  API_ORG_PROGRAM_GET_SUCCESS,
  API_ORG_PROGRAM_GET_FAILURE,
} from 'common/types';
import {ENDPOINT_ORGANIZATION_RELATIONSHIP} from 'common/endpoints';
import {buildOrgRelationshipOrganizationProgramsUrl, commonJwtHeader} from 'common/utils';

const getAllOrganizationProgramsByParams = (token, {isRestricted, orgId, subOrgId}) => {
  const endPointToUse =
  ENDPOINT_ORGANIZATION_RELATIONSHIP +
    buildOrgRelationshipOrganizationProgramsUrl(isRestricted, orgId, subOrgId);
  return {
    [CALL_API]: {
      endpoint: endPointToUse,
      headers: commonJwtHeader(),
      method: 'GET',
      types: [
        API_ORG_PROGRAM_GET_REQUEST,
        API_ORG_PROGRAM_GET_SUCCESS,
        API_ORG_PROGRAM_GET_FAILURE,
      ],
    },
  };
};

export default {
  getAllOrganizationProgramsByOrgId: (token, orgId) => {
    return getAllOrganizationProgramsByParams(token, {
      isRestricted: true,
      orgId,
    });
  },
  getAllOrganizationProgramsUnrestricted: (token) => {
    return getAllOrganizationProgramsByParams(token, {
      isRestricted: false,
    });
  },
};
